import { render, staticRenderFns } from "./LicencesDistributionRenewCart.vue?vue&type=template&id=4f5c0674&"
import script from "./LicencesDistributionRenewCart.vue?vue&type=script&lang=js&"
export * from "./LicencesDistributionRenewCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports